import type { DomainMapper } from '../types';

const fr: DomainMapper = {
  countryCode: 'fr',
  currency: 'EUR',
  dataAreaId: 'fr36',
  domain: 'kahrs-stage.iveo.store',
  environment: 'stage',
  flagUrl: '/flags/FR.svg',
  languagePrimary: true,
  locale: 'fr',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-fr.xml',
  storyblokBasePath: 'fr',
  url: 'https://kahrs-stage.iveo.store/fr',
  algoliaIndex: 'b2b-fr-fr-FR-products',
  algoliaIndexAutocomplete: 'b2b-fr-fr-FR-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1622,
  subFolder: true,
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1622,
    algoliaIndex: 'b2b-fr-fr-FR-products',
    algoliaIndexAutocomplete: 'b2b-fr-fr-FR-products_query_suggestions',
    displayIncVat: false,
    default: true,
    productBasePath: 'b2b/produit',
    sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-fr.xml',
    features: {
      enableCheckoutV2: true,
    },
  },
  b2c: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: '',
    applicationId: 1648,
    algoliaIndex: 'b2c-fr-fr-FR-products',
    algoliaIndexAutocomplete: 'b2c-fr-fr-FR-products_query_suggestions',
    displayIncVat: true,
    default: false,
    productBasePath: 'produit',
    sitemapUrl: 'https://kahrs.stage3.iveo.se/storage/sitemaps/sitemap-fr-b2c.xml',
    features: {
      enableNorceCheckoutAddressUpdates: true,
    },
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
    sampleInventory: true,
    disableShipToConsumer: true,
    onlyAllowCustomerEditAddressesForSamples: true,
  },
  norceCdnBaseUrl: 'https://kahrs.stage.cdn-norce.tech',
} as DomainMapper;

export default fr;
